module.exports = __webpack_public_path__ + "static/media/heroimage.d74de905.png";